import { loader } from 'graphql.macro'

export default function invoicesQuery ({ dataLoaders, queryKey }) {
  const [,
    haulerId,
    sort,
    invoiceNumber = null,
    accountName = null,
    statuses = null,
    startDate = null,
    endDate = null,
    pager = null,
    clientId = null
  ] = queryKey
  // Having to maintain this map is a bit of a pain, but we can't store underscores in the query parameters with the
  // ObjectParam type, so we need this to go from camelCase to our GraphQL enum CAPITALIZED_UNDERSCORE
  const sortColumnEnumMap = {
    invoiceNumber: 'DISPATCHER_INVOICE_NUMBER',
    qboDocNumber: 'QBO_DOC_NUMBER',
    qboNumber: 'QBO_DOC_NUMBER',
    accountName: 'ACCOUNT_NAME',
    createdAt: 'CREATED_AT',
    qboUploadStatus: 'QBO_UPLOAD_STATUS',
    billingStatus: 'BILLING_STATUS',
    status: 'STATUS',
    lastSent: 'LAST_SENT'
  }

  const sortColumnEnum = sortColumnEnumMap[sort.column]
  if (!sortColumnEnum) {
    return Promise.reject(new Error(`Invalid sort.column: ${sort.column}`))
  }

  let graphQLVariables = {
    haulerId,
    sortColumn: sortColumnEnum,
    sortDirection: sort.direction.toUpperCase(),
    invoiceNumber,
    accountName,
    startDate,
    endDate,
    clientId,
    statuses: statuses ? (Array.isArray(statuses) ? statuses : [statuses]) : null
  }

  if (pager) {
    const paginatedVariables = {
      before: pager.direction === 'before' ? pager.cursor : null,
      after: pager.direction === 'after' ? pager.cursor : null,
      first: pager.direction === 'after' ? Number(pager.pageSize) : null,
      last: pager.direction === 'before' ? Number(pager.pageSize) : null
    }
    graphQLVariables = { ...graphQLVariables, ...paginatedVariables }
  }

  const invoicesSchema = loader('./invoicesV2.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(invoicesSchema, graphQLVariables)
}
